const Parse = global.Parse;
import { Taxonomy } from 'domain';
import CommonUtils from 'utils/CommonUtils';

const TAXONOMY_FIELDS = Object.keys(Taxonomy.DEFAULTS);

const classMap = {
    subject: 'Subject',
    reproduction: 'Reproduction',
    nativityType: 'NativityType',
    invasiveStatus: 'InvasiveStatus',
    securityType: 'SecurityType',
    taxonomyType: 'TaxonomyType',
    taxonomyCategory: 'TaxonomyCategory',
    parent: 'Taxonomy',
    protectedStatus: 'ProtectedStatus',
    sRank: 'SRank',
    rigcn: 'RIGCN',
    rinhsStatus: 'ProtectedStatus',
}

const get = (taxonomyId) => {
    const query = new Parse.Query(Taxonomy)
        .select(TAXONOMY_FIELDS);

    return {
        type: 'GET_TAXONOMY',
        meta: { taxonomyId },
        payload: query.get(taxonomyId),
    };
};

const set = (taxonomy) => {
    return {
        type: 'SET_TAXONOMY',
        meta: { taxonomy },
        payload: Promise.resolve(taxonomy),
    };
};

const save = (taxonomy) => {
    return {
        type: 'SAVE_TAXONOMY',
        payload: (async () => {
            let taxonomyToSave;
            if (taxonomy.objectId) {
                const query = new Parse.Query(Taxonomy);
                taxonomyToSave = await query.get(taxonomy.objectId);
            } else {
                taxonomyToSave = new Taxonomy();
            }
            
            taxonomyToSave.set('primaryName', taxonomy.primaryName);
         
            Object.keys(classMap).forEach(classKey => {
                const className = classMap[classKey];
                const classValue = taxonomy[classKey];
                if (classValue) {
                    const classPointer = CommonUtils.createPointer(className, classValue);
                    taxonomyToSave.set(classKey, classPointer);
                }
            });
         
            const savedTaxonomy = await taxonomyToSave.save();
            return savedTaxonomy;
        })()
    };
};

const list = (filters = {}) => {
  const query = new Parse.Query(Taxonomy)
      .select(TAXONOMY_FIELDS)
      .include(['subject', 'reproduction', 'nativityType', 'invasiveStatus', 'securityType',]);
  
  if (filters.name) {
      const nameQuery = new Parse.Query('Name')
          .matches('name', new RegExp(filters.name, 'i'));
          
      query.matchesQuery('name', nameQuery);
  }

  if (filters.limit) {
      query.limit(filters.limit);
  }

  if (filters.skip) {
      query.skip(filters.skip);
  }

  return {
      type: 'LIST_TAXONOMY',
      meta: { filters },
      payload: query.find()
  };
};

const clear = () => ({
    type: 'CLEAR_TAXONOMY',
    meta: {},
    payload: Promise.resolve(null)
});

const checkPrimaryNameExists = (primaryName, excludeTaxonomyId = null) => {
    const query = new Parse.Query(Taxonomy)
        .equalTo('primaryName', primaryName);
    
    if (excludeTaxonomyId) {
        query.notEqualTo('objectId', excludeTaxonomyId);
    }

    return {
        type: 'CHECK_PRIMARY_NAME',
        payload: query.first()
    };
};

const deleteTaxonomy = (taxonomyId) => {
    return {
        type: 'DELETE_TAXONOMY',
        payload: (async () => {
            const nameQuery = new Parse.Query('Name');
            const taxonomyPointer = CommonUtils.createPointer('Taxonomy', taxonomyId);
            nameQuery.equalTo('taxonomy', taxonomyPointer);
            const taxonomyNames = await nameQuery.find();
            
            const identifierQuery = new Parse.Query('AlternateIdentifier');
            identifierQuery.equalTo('taxonomy', taxonomyPointer);
            const alternateIdentifiers = await identifierQuery.find();
            
            if (taxonomyNames.length > 0) {
                await Parse.Object.destroyAll(taxonomyNames);
            }
            
            if (alternateIdentifiers.length > 0) {
                await Parse.Object.destroyAll(alternateIdentifiers);
            }
            
            const taxonomyQuery = new Parse.Query(Taxonomy);
            const taxonomy = await taxonomyQuery.get(taxonomyId);
            await taxonomy.destroy();
            
            return {
                taxonomyId,
                deletedNamesCount: taxonomyNames.length,
                deletedIdentifiersCount: alternateIdentifiers.length
            };
        })()
    };
};

export default {
    get,
    set,
    save,
    list,
    clear,
    checkPrimaryNameExists,
    deleteTaxonomy
};
